module.exports = __webpack_public_path__ + "static/media/ic-chrome.79ff8cde.svg";